import _ from 'underscore';

const MinimumCompatibleBrowserVersion = _.constant({
  IE: 11.0,
  Chrome: -1, // -1 means all versions
  Firefox: 38.0,
  Safari: 9.0,
  Opera: -1,
  Edge: -1,
});

function getBrowserInfo() {
  const ua = navigator.userAgent;
  const matches = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  let t;
  // check for IE
  if (/trident/i.test(matches[1])) {
    t = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: parseFloat(t[1] || '0') };
  }

  // Other
  const app = matches[2] ? [matches[1], matches[2]] : [navigator.appName, navigator.appVersion, '-?'];
  t = ua.match(/version\/(\d+)/i);
  if (t != null) {
    app.splice(1, 1, t[1]);
  }

  return { name: app[0], version: parseFloat(app[1]) };
}

export function isCompatibleBrowser() {
  const { name, version } = getBrowserInfo();

  if (!_.has(MinimumCompatibleBrowserVersion(), name)) {
    return false;
  }
  const minVer = MinimumCompatibleBrowserVersion()[name];
  if (minVer > version) {
    return false;
  }


  return true;
}

// Returns the version of Internet Explorer or a -1
// (indicating the use of another browser).
function getInternetExplorerVersion() {
  const v = getBrowserInfo();
  if (v.name === 'IE') {
    return v.version;
  }

  return -1;
}

/* !!! CAREFUL !!! */
/* This function won't work for IE10 or above */
function isIEXOrLess(v) {
  const version = getInternetExplorerVersion();
  return version !== -1 && version < v;
}

export const isIE8OrLess = isIEXOrLess(9.0);
export const isIE9OrLess = isIEXOrLess(10.0);
export const getIEVersion = getInternetExplorerVersion;
